'use strict';

exports.setImmediate = typeof setImmediate === 'function'
  ? setImmediate
  : function(fn){
    process.nextTick(fn.bind.apply(fn, arguments));
  };



//////////////////
// WEBPACK FOOTER
// ./node_modules/utility/lib/polyfill.js
// module id = 280
// module chunks = 1